// Video-Konfiguration für Supabase Storage
// Die Videos werden aus dem Supabase Storage Bucket geladen

export const videoConfig = {
  bucketName: 'campagnefiles', // Name des Supabase Storage Buckets
  folderPath: '64ba623b-a57e-42c1-951d-0fef7035a435', // Unterordner im Bucket
  heroVideoPath: 'hero/hero-video.mp4', // Pfad zum Hero-Video im Bucket
  videos: [
    {
      id: 1,
      name: 'Mercedes',
      fileName: 'mercedes-1.mp4', // Dateiname im Supabase Bucket
      description: 'Mercedes Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 2,
      name: 'Mercedes',
      fileName: 'mercedes-2.mp4',
      description: 'Mercedes Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 3,
      name: 'Nutella',
      fileName: 'nutella-1.mp4',
      description: 'Nutella Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 4,
      name: 'Nutella',
      fileName: 'nutella-2.mp4',
      description: 'Nutella Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 5,
      name: 'Nutella',
      fileName: 'nutella-3.mp4',
      description: 'Nutella Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 6,
      name: 'Audi',
      fileName: 'audi-1.mp4',
      description: 'Audi Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 7,
      name: 'Persil',
      fileName: 'persil-1.mp4',
      description: 'Persil Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 8,
      name: 'Persil',
      fileName: 'persil-2.mp4',
      description: 'Persil Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 9,
      name: 'Audi',
      fileName: 'audi-2.mp4',
      description: 'Audi Kampagne - Beispiel für korrektes Video-Format'
    },
    {
      id: 10,
      name: 'Audi',
      fileName: 'audi-3.mp4',
      description: 'Audi Kampagne - Beispiel für korrektes Video-Format'
    }
  ]
}
